import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { formatPrice } from '@grandvisionhq/utils';
import { CartDiscountType } from '../../../../../../hooks/useCartDiscountsQuery/types.js';
import '@grandvisionhq/graphql';
import '../../../../../../operations/queries/get-accessories-by-slug.js';
import '../../../../../../operations/queries/get-contact-lens-by-slug.js';
import '../../../../../../operations/queries/get-frames-by-slug.js';
import '../../../../../../operations/queries/get-solutions-by-slug.js';
import '../../../../../../operations/queries/get-sunglasses-by-slug.js';
import '../../../../../../operations/queries/get-ready-reader-by-slug.js';
import '../../../../../../operations/queries/get-cart-discounts-by-promotion-identifier.js';
import '../../../../../../operations/queries/get-manufacturer-by-key.js';
import { SelectToggleButton } from '../../../SelectToggleButton/SelectToggleButton.js';
import { TileLayout } from '../../../TileLayout/TileLayout.js';

const getLabelKeys = (discountType, discountAmount, locale, currency)=>{
    switch(discountType){
        case CartDiscountType.PERCENT:
            return {
                titleKey: 'products.quantityDiscount.percent.title',
                subtitleKey: 'products.quantityDiscount.percent.subtitle',
                discountValue: discountAmount
            };
        case CartDiscountType.AMOUNT:
            const price = formatPrice({
                locale,
                currency,
                value: discountAmount,
                isCentAmount: false,
                fixedDecimals: false
            });
            return {
                titleKey: 'products.quantityDiscount.amount.title',
                subtitleKey: 'products.quantityDiscount.amount.subtitle',
                discountValue: price
            };
    }
};
const CartQuantityDiscountSelectBox = ({ item , isSelected , onClick , className  })=>{
    const { getFormattedLabel , locale , currency  } = useIntl();
    const { minimumQuantity , discount  } = item;
    const { amount  } = discount;
    const { titleKey , subtitleKey , discountValue  } = getLabelKeys(discount.type, amount, locale, currency);
    const title = getFormattedLabel(titleKey, {
        labelData: {
            amount: discountValue
        }
    });
    const subtitle = getFormattedLabel(subtitleKey, {
        labelData: {
            minimumQuantity
        }
    });
    return /*#__PURE__*/ React.createElement(SelectToggleButton, {
        value: item,
        isSelected: isSelected,
        onClick: onClick,
        className: className
    }, /*#__PURE__*/ React.createElement(TileLayout, {
        title: title,
        subtitle: subtitle
    }));
};

export { CartQuantityDiscountSelectBox };
//# sourceMappingURL=CartQuantityDiscountSelectBox.js.map
